import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Observable } from "rxjs";
import { AuthService } from "src/services/auth/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private jwtHelper: JwtHelperService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const token = this.jwtHelper.tokenGetter();
    const isAuthenticated = this.authService.isAuthenticated();
    const loginUrl = "/login";
    const homeUrl = "/";

    // 1. Vérifier la présence du token
    if (!token) {
      return this.redirectToLoginWithReturnUrl(state.url);
    }

    // 2. Vérifier l'authentification
    if (!isAuthenticated) {
      // Si on est déjà sur la page d'accueil, ne pas rediriger à l'infini
      if (state.url === homeUrl) {
        return true;
      }
      this.router.navigate([homeUrl]);
      return false;
    }

    // 3. Tout est valide
    return true;
  }

  private redirectToLoginWithReturnUrl(returnUrl: string): boolean {
    // Ne pas inclure l'URL de login elle-même comme returnUrl
    if (returnUrl !== "/login") {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: returnUrl },
      });
    } else {
      this.router.navigate(["/login"]);
    }
    return false;
  }
}
